import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NavBar } from './nav-bar/nav-bar';
import { Navigation } from './navigation/navigation';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, Navigation, NavBar, RouterModule],
  templateUrl: './layout.html',
  styleUrl: './layout.scss'
})
export class Layout {
  private router = inject(Router);

  navCollapsed: boolean = false;
  navCollapsedMob: boolean = false;
  windowWidth: number = window.innerWidth;

  ngOnInit() {}

  get isSubnav(): boolean {
    const url = this.router.url;
    return url === '/sub-navigation' || url.startsWith('/sub-navigation/');
  }

  navMobClick() {
    const nav = document.querySelector('app-navigation.pcoded-navbar');

    if (this.navCollapsedMob && nav && !nav.classList.contains('mob-open')) {
      this.navCollapsedMob = !this.navCollapsedMob;
      setTimeout(() => {
        this.navCollapsedMob = !this.navCollapsedMob;
      }, 100);
    } else {
      this.navCollapsedMob = !this.navCollapsedMob;
    }
  }

  // this is for eslint rule
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeMenu();
    }
  }

  closeMenu() {
    const nav = document.querySelector('app-navigation.pcoded-navbar');

    if (nav && nav.classList.contains('mob-open')) {
      nav.classList.remove('mob-open');
    }
  }
}
